import React from "react";
import { useCurrentUserStore } from "@src/state/currentUserState";
import { getHasRole } from "@src/utils/permission";
import { Navigate } from "react-router-dom";

interface RequiresRoleContainerProps {
  children?: React.ReactNode;
  element?: React.ReactNode;
  fallback?: React.ReactNode;
  role?: string | null;
  roles?: string[]; // Note: This will be an OR operation (user only needs one role in the list). For AND operations, wrap the component in multiple containers
}

export default function RequiresRoleContainer({
  role = null,
  roles = [],
  children,
  element,
  fallback = null,
}: RequiresRoleContainerProps): React.ReactNode | null {
  const { currentUser } = useCurrentUserStore();
  const isRoute = !!element;

  if (!currentUser) {
    return fallback;
  }

  const requiresRole = !!role;
  const requiresOneOfRoles = roles.length > 0;

  if (
    (!requiresRole && !requiresOneOfRoles) ||
    (requiresRole && requiresOneOfRoles) ||
    (!children && !element)
  ) {
    // Should only pass in one or the other, also require children or an element
    console.warn("Invalid configuration for RequiresRoleContainer!");
    return fallback;
  }

  let hasRole = false;
  if (requiresRole) {
    hasRole = getHasRole(currentUser, role);
  } else if (requiresOneOfRoles) {
    let hasOneOfRoles = false;

    roles.map((r) => {
      if (!hasOneOfRoles && getHasRole(currentUser, r)) {
        hasOneOfRoles = true;
      }
    });

    if (hasOneOfRoles) {
      hasRole = true;
    }
  }

  const content = isRoute ? <>{element}</> : children;
  if (isRoute) {
    fallback = <Navigate to="/" replace />;
  }
  return hasRole ? content : fallback;
}
